import React from 'react';

interface TagProps {
  label: string;
  variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const variantClasses: Record<string, string> = {
  default:   'bg-slate-100 text-slate-700',
  primary:   'bg-blue-100 text-blue-800',
  secondary: 'bg-slate-200 text-slate-800',
  success:   'bg-emerald-100 text-emerald-800',
  warning:   'bg-amber-100 text-amber-800',
  error:     'bg-red-100 text-red-800',
  info:      'bg-sky-100 text-sky-800',
};

const sizeClasses: Record<string, string> = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export const Tag: React.FC<TagProps> = ({
  label,
  variant = 'default',
  size = 'md',
  className = ''
}) => {
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium transition-colors ${variantClasses[variant] || variantClasses.default} ${sizeClasses[size] || sizeClasses.md} ${className}`}
    >
      {label}
    </span>
  );
};